<template>
  <div class="section">
    <div class="container">
      <RegistrationCardAdmin
        v-if="this.$route.params.target == 'user'"
        @registrationSuccessful="
          $route.params.reroute == 'agency'
            ? $router.push({ name: 'Register', params: { target: 'agency' } })
            : $router.push({ name: 'Login' })
        "
      >
        <router-link class="ml-4 button" :to="{ name: 'Login' }">
          {{ $t("logIn") }}
        </router-link>
      </RegistrationCardAdmin>
      <RegistrationCardOrganization
        v-if="this.$route.params.target == 'organization' || this.$route.params.target == 'agency'"
      />
      <RegistrationCardTranslator
        v-if="this.$route.params.target == 'translator'"
        @registrationSuccessful="
          $router.push({
            name: 'TranslatorDashboard',
            params: { translatorId: $store.getters.getCurrentUser.uid },
          })
        "
      />
      <div v-if="this.$route.params.target == undefined">
        <div class="card" style="max-width: 700px; margin: auto">
          <div class="card-content">
            <p class="title">
              {{ $t("signUpTitle") }}
            </p>
            <p class="subtitle mt-2">
              {{ $t("registerAs") }}
            </p>

            <b-message type="is-primary" class="mt-0 mb-5">
              <div>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  class="mb-3"
                  @click="
                    $router.push({
                      name: 'Register',
                      params: { target: 'user' },
                    })
                  "
                >
                  {{ $t("registerAUserAccount") }}
                </b-button>
              </div>
              {{ $t("registerAUserAccountDesc") }}
            </b-message>

            <b-message type="is-primary" class="mt-0 mb-5">
              <div>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  class="mb-3"
                  @click="
                    $store.getters.getCurrentUser
                      ? $router.push({
                          name: 'Register',
                          params: { target: 'agency' },
                        })
                      : $router.push({
                          name: 'Register',
                          params: { target: 'user', reroute: 'agency' },
                        })
                  "
                >
                  {{ $t("registerAnAgency") }}
                </b-button>
              </div>
              {{ $t("registerAnAgencyDesc") }}
            </b-message>

            <b-message type="is-primary" class="mt-0 mb-5">
              <div>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  class="mb-3"
                  @click="
                    $router.push({
                      name: 'Register',
                      params: { target: 'translator' },
                    })
                  "
                >
                  {{ $t("registerATranslatorAccount") }}
                </b-button>
              </div>
              {{ $t("registerATranslatorAccountDesc") }}
            </b-message>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegistrationCardAdmin from "@/components/RegistrationCardAdmin.vue";
import RegistrationCardOrganization from "@/components/RegistrationCardOrganization.vue";
import RegistrationCardTranslator from "@/components/RegistrationCardTranslator.vue";
import { auth } from "@/firebase";

export default {
  name: "Registration",
  components: {
    RegistrationCardAdmin,
    RegistrationCardOrganization,
    RegistrationCardTranslator,
  },
  mounted() {
    document.title = this.$t("signUpTitle");
  },
  beforeDestroy() {
    document.title = "Qonda";
  },
  created() {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        if (user.isAnonymous) {
          this.$store.dispatch("logOutUser");
        }
      }
    });
  },
};
</script>
